import axios from '@/plugins/axios';
import { Response } from '@/types/common/Rest';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { handleApiResponse } from '@/utils/request';
import { IFiltroJurisprudencia, PageJurisprudencia } from '../types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/publico/jurisprudencia`;

class JurisprudenciaSelecionadaService {
  public async consultarJurisprudenciaSelecionada(
    filtro: IFiltroJurisprudencia
  ): Promise<Response<PageJurisprudencia>> {
    const url = `${BASE_URL}/find/jurisprudencias`;
    return handleApiResponse(() => axios.post(url, filtro));
  }

  public downloadAcordao(cdAcordao: number) {
    const urlRelatorio = `https://esaj.tjsp.jus.br/cjsg/getArquivo.do?cdAcordao=${cdAcordao}&cdForo=0`;
    window.open(urlRelatorio, '_blank');
  }

  public downloadSimplificado(cdJurisprudenciaList: number[]) {
    const urlRelatorio = `/mat-report/publico/gcn/api/v1.0/jurisprudencia?cdJurisprudenciaList=${cdJurisprudenciaList}`;
    window.open(`${urlRelatorio}&formato=S`, '_blank');
  }

  public downloadDetalhado(cdJurisprudenciaList: number[]) {
    const urlRelatorio = `/mat-report/publico/gcn/api/v1.0/jurisprudencia?cdJurisprudenciaList=${cdJurisprudenciaList}`;
    window.open(`${urlRelatorio}&formato=D`, '_blank');
  }
}

export default new JurisprudenciaSelecionadaService();
